export const ROLES = {
  ADMIN: 'admin',
  SECRETARY: 'secretary'
} as const;

export type UserRole = typeof ROLES[keyof typeof ROLES];

